/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useState } from 'react';
import { Actionable, Hidden, View } from '@az/starc-ui';
import Image from '@/components/NextImage';
import styles from './styles.module.scss';
import type { CarouselButtonType } from './types';

export const CarouselButton = ({ direction, hideButton, handleScroll }: CarouselButtonType) => {
  const [isMouseOver, setIsMouseOver] = useState(false);
  const containerStyle = direction === 'next' ? styles.nextButton : styles.previousButton;
  const imageStyle = direction === 'next' ? styles.nextButtonImage : styles.previousButtonImage;

  return (
    <Hidden hide={hideButton}>
      <View>
        <Actionable
          as="button"
          onClick={handleScroll}
          attributes={{
            'data-testid':
              direction === 'next'
                ? 'visual-filters-next-button'
                : 'visual-filters-previous-button',
          }}
        >
          <View
            height="64px"
            width="57px"
            align="end"
            justify="center"
            className={containerStyle}
            attributes={{
              onMouseEnter: () => setIsMouseOver(true),
              onMouseLeave: () => setIsMouseOver(false),
            }}
          >
            <Image
              src={
                isMouseOver ? '/images/arrow_right_hover.svg' : '/images/arrow_right_initial.svg'
              }
              onMouseOver={() => Image({ src: '/images/arrow_right_hover.svg' })}
              height="64"
              width="57"
              alt="next"
              className={imageStyle}
            />
          </View>
        </Actionable>
      </View>
    </Hidden>
  );
};
